import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import PropTypes from 'prop-types';
import { Button, Icon, HideText } from '@fashionnovateam/nova-ui-toolkit';
import PrintableApplication from '../PrintableApplication/PrintableApplication';
import isCompliance from '../../Lib/Utils/Role/is-compliance';

export default function PrintApplicationButton(props) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({ content: () => componentRef.current });

  if (!isCompliance(props.currentUser)) return null;

  return (
    <div>
      <div style={{ display: 'none' }}>
        <div ref={componentRef}>
          <PrintableApplication vendor={props.vendor} />
        </div>
      </div>
      <Button size="sm" color="secondary" onClick={handlePrint}>
        <Icon name="printer" />
        <HideText notAbove="lg">Print</HideText>
      </Button>
    </div>
  );
}

PrintApplicationButton.propTypes = {
  currentUser: PropTypes.shape({}).isRequired,
  vendor: PropTypes.shape({}).isRequired,
};
